module.exports = __webpack_public_path__ + "media/images/arrow-left-black-8cc7b7f7454bb75bf72d94eca1636fab.svg";